'use server';
import { actionErrorMessage } from '@/shared/infrastructure/logging/actionError';

import type { ActionResult } from '@/shared/types/actions';
import { SessionService } from '@/contexts/authentication';
import { StoryService } from '@/contexts/stories/services/StoryService';
import { EDIT_FORBIDDEN, guardEdit } from '@/contexts/pipeline-v2/edits/guardAction.server';
import type { TextBlock } from '@/contexts/stories/types/story';

export async function regenerateBlock(
  storyId: string,
  blockId: string,
  context?: string,
): Promise<ActionResult<TextBlock>> {
  try {
    const familyId = await SessionService.getFamilyId();
    const userId = await SessionService.getUserId();
    if (!familyId || !userId) return { success: false, error: 'Not authenticated' };

    const blocked = await guardEdit({ storyId, kind: 'block_regen' });
    if (blocked) return { success: false, error: blocked.message, code: EDIT_FORBIDDEN };

    const { block: updatedBlock } = await StoryService.regenerateBlock({
      storyId,
      familyId,
      userId,
      blockId,
    });

    return { success: true, data: updatedBlock };
  } catch (e: unknown) {
    return { success: false, error: actionErrorMessage('generation', e) };
  }
}
